import React, { useEffect } from 'react'
import { SessionFilterViewProps } from './model'
import { selectSessionFilterContactIds, setSessionFilterContactIds } from '../../store/sessionFilter/sessionFilter'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { useSearchParams } from 'react-router-dom'
import { useContactFilter } from '../../apps/professional-app/fa/common/contactFilter/hooks'
import { ContactFilter } from '../../apps/professional-app/fa/common/contactFilter/ContactFilter'

export const SessionContactFilter: React.FC<SessionFilterViewProps> = ({ filterType, disabled = false, onFilterChanged }) => {
  const dispatch = useAppDispatch()
  const sessionFilterContactIds = useAppSelector(selectSessionFilterContactIds)
  const {
    contactFilterValues,
    selectedContactId,
    setSelectedContactId,
    resetContactFilter,
    isLoading: contactsLoading,
    handleSearchInputChange,
  } = useContactFilter()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    if (sessionFilterContactIds && sessionFilterContactIds.length) {
      setSelectedContactId(sessionFilterContactIds[0])
    } else {
      resetContactFilter()
    }
  }, [sessionFilterContactIds, setSelectedContactId, resetContactFilter])

  const handleContactIdChanged = (selectedId: string) => {
    setSelectedContactId(selectedId)
    searchParams.set('contactId', selectedId)
    searchParams.delete('filterId')
    onFilterChanged && onFilterChanged(searchParams)
    dispatch(setSessionFilterContactIds([selectedId]))
  }

  return (
    <ContactFilter
      contactFilterValues={contactFilterValues}
      selectedContactId={selectedContactId}
      onSelectedChanged={handleContactIdChanged}
      disabled={contactsLoading || disabled}
      onSearchInputChange={handleSearchInputChange}
    />
  )
}
